import { useNavigate } from "react-router-dom";
import "../X/X.css"

const X = () => {
    const navigate = useNavigate();
    
    return (
        <div>
            <div className="header">
                <button className="nav-button" onClick={() => navigate("/")}>Tasks</button>
                <button className="nav-button" onClick={() => navigate("/shop")}>Shop</button>
                <button className="nav-button" onClick={() => navigate("/X")}>X</button>
            </div>
            <div className="towers">
                <div className="tower1" onClick={() => navigate("/tower", { state: { towerNumber: 1 } })}>
                    <h1 className="tower1-h">1</h1>
                </div>
                <div className="tower2" onClick={() => navigate("/tower", { state: { towerNumber: 2 } })}>
                    <h1 className="tower2-h">2</h1>
                </div>
                <div className="tower3" onClick={() => navigate("/tower", { state: { towerNumber: 3 } })}>
                    <h1 className="tower3-h">3</h1>
                </div>
            </div>
        </div>
    )
}
export default X;